'use strict';
var arrayWith = require('../internals/array-with');
var toIndexedObject = require('../internals/to-indexed-object');
var $Array = Array;

/**
 * Array.prototype.with
 * @param {number} index 索引
 * @param {any} value 要分配给指定索引的任何值
 * @returns {any[]} 一个全新的数组，其中 index 索引处的元素被替换为 value
 */
module.exports = {
  target: Array,
  property: 'with',
  proto: true,
  handler: function(index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  },
};
